export  const MainData = {
    "mainLogo": "Base/luxinhotel_logo.svg",
    "dict": [
        {
            "title": "En",
            "filename": "en",
            "countryName": "GB",
            "dir": "ltr",
            "default": true
        },
        {
            "title": "Fa",
            "filename": "fa",
            "countryName": "IR",
            "dir": "rtl",
            "default": false
        }
    ],
    "nav": [
        {
            "route": "/",
            "title": {
                "fa": "خانه",
                "en": "Home",
            } ,submenu: []
        },
        {
          "route": "",
            "title": {
                "fa": "مقصد تور",
                "en": "Tour destination",
                    },
                submenu: [
                    {
                 "route": "/tour2",
                  "title": {
                    "fa": "2مقصد تور",
                    "en": "Tour destination"
                }
            },
            {
                "route": "/tour3",
                 "title": {
                   "fa": "3مقصد تور",
                   "en": "Tour destination"
               }
           },
           {
            "route": "/tour4",
             "title": {
               "fa": "4مقصد تور",
               "en": "Tour destination"
           }
       }
            ]
            },
                       
           
        
        {
            "route": "/travel-agency",
            "title": {
                "fa": "آژانس مسافرتی",
                "en": "Travel agencies"
            } ,submenu: []
        },
        {
            "route": "/tour-operator",
            "title": {
                "fa": "کارگزار تور",
                "en": "Tour operators"
            } ,submenu: []
        },
        {
            "route": "/contactus",
            "title": {
                "fa": "تماس باما",
                "en": "Contact Us"
            } ,submenu: []
        },
        {
            "route": "/aboutus",
            "title": {
                "fa": "درباره ما",
                "en": "About Us"
            } ,submenu: []
        },
    ],
    "footer": [
        {
            "route": "/",
            "title": {
                "fa": "خانه",
                "en": "Home"
            } ,submenu: []
        },
        {
            "route": "/contactus",
            "title": {
                "fa": "تماس باما",
                "en": "Contact Us"
            } ,submenu: []
        },
        {
            "route": "/aboutus",
            "title": {
                "fa": "درباره ما",
                "en": "About Us"
            } ,submenu: []
        },
    ],
    "login": {
        "title": {
            "fa": "ورود",
            "en": "Login"
        },
        "ctas": [
            {
                "icon": "/base/dash.svg",
                "title": {
                    "fa": "پروفایل",
                    "en": "Profile"
                },
                "premission": [],
                "route": "/profile/dashboard",
            },
            {
                "icon": "/base/login.svg",
                "title": {
                    "fa": "خروج",
                    "en": "Logout"
                },
                "route": "/logout",
            }
        ]
    },
    "texts": {
        "footer-desc": {
            "fa": "لوکسین تریپ یک پلتفرم پیشرو  بین المللی برای همکاری در صنعت گردشگری است. این پلتفرم متعهد به ارائه راه‌حل‌های نوآورانه و با کیفیت بالا است که به آژانس‌ها و کارگزاران در هر اندازه‌ای کمک می‌کند تا به پتانسیل کامل خود برسند.",
            "en": "Luxin Trip is a leading international platform for collaboration in  tourism industry. The platform is committed to delivering innovative, high-quality solutions that help agencies and brokers of all sizes reach their full potential."
        },
        "footer-links-title": {
            "fa": "لینک ها",
            "en": "LINKS"
        },
        "footer-contactus-title": {
            "fa": "ارتباط با ما",
            "en": "CONTACT US"
        },
        "footer-findus-title": {
            "fa": "ما کجاییم",
            "en": "FIND US"
        },
        "address": {
            "fa": "ایران، تهران، خیابان شریعتی، کوچه مینوی، پلاک 731 ،واحد 1",
            "en": "Unit 1, No 731,At the corner of Minavi St, Shariati Ave, Tehran, Iran"
        },
        "phone": {
            "fa": "+98 (21) 88147216 , +98 (21) 88147635",
            "en": "+98 (21) 88147216 , +98 (21) 88147635"
        },
        "email": {
            "fa": "info@farazandishan.com",
            "en": "info@farazandishan.com"
        },
        "working hour": {
            "fa": "شنبه - چهارشنبه: ۹ صبح - ۵ بعد از ظهر",
            "en": "Saturday—Wednesday: 9:00AM-5:00PM"
        },
        "copyright": {
            "fa": "تمامی حقوق متعلق به شرکت فرازاندیشان می باشد",
            "en": "Copyright - Faraz Andishan Human Recource Company"
        },
        "language": {
            "fa": "زبان",
            "en": "language"
        }
    }
}